<template>
  <div>
    <router-view :key="'department-' + $route.fullPath" />
    <view-department-component v-if="viewDepartment" />
  </div>
</template>

<script>
import ViewDepartmentComponent from "./components/ViewDepartmentComponent";
export default {
  name: "DepartmentsComponent",
  components: {
    ViewDepartmentComponent,
  },
  data() {
    return {
      viewDepartment: false,
    };
  },
};
</script>

<style lang="scss">
.content {
  &.settings-container {
    padding: 0 !important;
    .heading {
      display: flex;
      flex-direction: row;
      padding: 28px 0 29px;
      margin: 0 80px;
      button.invite {
        margin-left: auto;
        padding: 0;
        font-family: "Roboto", sans-serif;
        font-size: 0.875rem;
        line-height: 1.5rem;
        font-weight: 500;
        color: #00b9cb;
        display: flex;
        flex-direction: row;
        align-items: center;
        @include base-transition(ease all 0.15s);

        i {
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 8px;
          font-size: 16px;
          @include base-transition(ease all 0.15s);
        }

        &:hover {
          color: #00b9cb;

          i {
            color: #00b9cb;
          }
        }
      }
    }
  }
}
/*.table-heading {
      padding: 5px 16px 6px 80px;
      background: #fafafa;
      border-top: 1px solid #efefef;
      border-bottom: 1px solid #efefef;
      display: flex;
      flex-direction: row;

      span.heading-label {
        display: inline-flex;
        color: #999999;
        font-family: "Roboto", sans-serif;
        font-size: 0.75rem;
        font-weight: 500;
        line-height: 1.5rem;
        margin-right: 16px;
        text-transform: capitalize;

        &.department,
        &.first-label{
          width: 380px;
          margin-right: 20px;
        }
      }
    }*/
</style>
